var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "products-ctn"
  }, [_c('h4', {
    staticClass: "text-capitalize font-weight-bold title"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_products')))]), _c('div', {
    staticClass: "content mr-4"
  }, [_vm.isATPEnabled ? _c('div', {
    staticClass: "mt-6"
  }, [_c('div', {
    staticClass: "d-flex flex-wrap align-center"
  }, [_vm.hasATPEditPermission ? _c('v-btn', {
    staticClass: "text-uppercase",
    attrs: {
      "color": "#15BBF0"
    },
    on: {
      "click": _vm.handleConnectProduct
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('amazon_transparency_connect_product')) + " ")]) : _vm._e(), _c('v-spacer'), _vm.hasConnectedProducts || _vm.searchProducts || _vm.hasLoadedProducts ? _c('v-text-field', {
    staticClass: "d-flex align-center custom-search-field mt-4 mt-sm-0",
    attrs: {
      "outlined": "",
      "dense": "",
      "placeholder": _vm.$t('amazon_transparency_search_by'),
      "single-line": "",
      "persistent-hint": ""
    },
    on: {
      "input": _vm.handleSearchInput
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "black"
          },
          on: {
            "click": _vm.handleSearchIconClick
          }
        }, [_vm._v(" " + _vm._s(_vm.searchProducts ? 'mdi-close' : 'mdi-magnify') + " ")])];
      },
      proxy: true
    }], null, false, 4028453153),
    model: {
      value: _vm.searchProducts,
      callback: function ($$v) {
        _vm.searchProducts = $$v;
      },
      expression: "searchProducts"
    }
  }) : _vm._e()], 1), _vm.hasConnectedProducts || _vm.searchProducts || _vm.hasLoadedProducts ? _c('div', {
    staticClass: "mt-6"
  }, [_c('v-data-table', {
    staticClass: "custom-data-table",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.atpProducts,
      "loading": _vm.isLoadingATPProducts,
      "options": _vm.options,
      "server-items-length": _vm.totalATPProducts,
      "items-per-page": 10,
      "footer-props": {
        'items-per-page-text': '',
        'disable-items-per-page': true
      },
      "item-value": "id",
      "loading-text": _vm.$t('amazon_transparency_loading_products'),
      "item-class": function (item) {
        return item.id === _vm.updatedATPProductId ? 'highlighted-row' : '';
      },
      "hide-default-footer": ""
    },
    on: {
      "update:options": function ($event) {
        _vm.options = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "header.product_name",
      fn: function (_ref) {
        var header = _ref.header;
        return [_c('span', {
          staticClass: "text-no-wrap"
        }, [_vm._v(_vm._s(header.text))])];
      }
    }, {
      key: "header.uploaded_code_count",
      fn: function (_ref2) {
        var header = _ref2.header;
        return [_c('div', {
          staticClass: "d-flex align-center justify-center text-no-wrap"
        }, [_c('span', [_vm._v(_vm._s(header.text))]), _c('v-tooltip', {
          attrs: {
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref3) {
              var on = _ref3.on,
                attrs = _ref3.attrs;
              return [_c('v-icon', _vm._g(_vm._b({
                staticClass: "ml-2",
                attrs: {
                  "color": "primary",
                  "size": "18"
                }
              }, 'v-icon', attrs, false), on), [_vm._v(" mdi-help-circle-outline ")])];
            }
          }], null, true)
        }, [_c('div', {
          staticClass: "help-container"
        }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_status_help')))])])], 1)];
      }
    }, {
      key: "item.sku",
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('span', {
          staticClass: "wrap-cell-text"
        }, [_vm._v(_vm._s(item.sku))])];
      }
    }, {
      key: "item.connection_status",
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('span', {
          staticClass: "text-no-wrap",
          class: [item.status !== 'in progress' ? 'text-capitalize' : '', _vm.getStatusClass(item.status)]
        }, [_vm._v(" " + _vm._s(item.status) + " ")])];
      }
    }, {
      key: "item.is_active",
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_c('span', {
          staticClass: "text-capitalize",
          class: _vm.getStatusClass(item.status)
        }, [item.is_active ? _c('v-icon', {
          attrs: {
            "color": "green",
            "size": "24"
          }
        }, [_vm._v("mdi-check")]) : _c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("mdi-close")])], 1)];
      }
    }, {
      key: "item.actions",
      fn: function (_ref7) {
        var item = _ref7.item;
        return [_c('v-menu', {
          attrs: {
            "offset-y": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref8) {
              var on = _ref8.on,
                attrs = _ref8.attrs;
              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "icon": ""
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', {
                attrs: {
                  "color": "primary"
                }
              }, [_vm._v("mdi-dots-vertical")])], 1)];
            }
          }], null, true)
        }, [_c('v-list', [_c('v-list-item', {
          on: {
            "click": function ($event) {
              return _vm.viewItemDetails(item);
            }
          }
        }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('amazon_transparency_view_details')))])], 1), item.status !== 'connected' && _vm.hasATPEditPermission ? _c('v-list-item', {
          on: {
            "click": function ($event) {
              return _vm.reconnectItem(item);
            }
          }
        }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('amazon_transparency_reconnect')))])], 1) : _vm._e()], 1)], 1)];
      }
    }, {
      key: "footer",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex justify-end mt-5 mb-4"
        }, [_c('v-pagination', {
          staticClass: "flex-grow-0",
          attrs: {
            "length": _vm.totalPages,
            "total-visible": 7
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
            }
          },
          model: {
            value: _vm.options.page,
            callback: function ($$v) {
              _vm.$set(_vm.options, "page", $$v);
            },
            expression: "options.page"
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 685819133)
  })], 1) : _vm._e(), _vm.hasNoConnectedProducts && !_vm.searchProducts && !_vm.hasLoadedProducts ? _c('div', {
    staticClass: "flex justify-center align-center no-products-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('amazon_transparency_no_products')) + " ")]) : _vm._e()]) : _vm._e(), !_vm.isATPEnabled ? _c('div', [_c('div', {
    staticClass: "mt-10"
  }, [_c('p', {
    staticClass: "content-text"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_auto_register')))]), _c('p', {
    staticClass: "content-text mt-6"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_already_register')))]), _vm._v(" " + _vm._s(_vm.$t('amazon_transparency_use_module')) + " ")]), _c('p', {
    staticClass: "mt-6 content-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('amazon_transparency_please_contact')) + " "), _c('a', {
    staticClass: "text-decoration-underline",
    attrs: {
      "href": "mailto:support@scantrust.com"
    }
  }, [_vm._v("support@scantrust.com")]), _vm._v(" " + _vm._s(_vm.$t('amazon_transparency_enable_feature')) + " ")])])]) : _vm._e()]), _c('ConnectProductDialog', {
    attrs: {
      "display-connect-product-dialog": _vm.displayDialog
    },
    on: {
      "update:displayConnectProductDialog": _vm.closeDialog
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }